(() => {
  const initialized = new WeakSet();

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0);
    const token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    let amount;
    if (token === 'amount_no_decimals') {
      amount = (value / 100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    } else if (token === 'amount_with_comma_separator') {
      amount = (value / 100).toFixed(2).replace('.', ',');
    } else if (token === 'amount_no_decimals_with_comma_separator') {
      amount = Math.round(value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
      amount = (value / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  };

  const initProduct = (root) => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    let moneyFormat = '${{amount}}';
    const moneyNode = root.querySelector('[data-tfw-money-format]');
    if (moneyNode) {
      try { moneyFormat = JSON.parse(moneyNode.textContent); } catch (_) { /* use fallback */ }
    }

    const variantSelect = root.querySelector('[data-tfw-variant-select]');
    const addButton = root.querySelector('[data-tfw-add-button]');
    const addLabel = root.querySelector('[data-tfw-add-label]');
    const currentPrice = root.querySelector('[data-tfw-current-price]');
    const comparePrice = root.querySelector('[data-tfw-compare-price]');
    const notifyLink = root.querySelector('[data-tfw-notify]');

    const setVariantState = () => {
      if (!variantSelect) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      const price = Number(option.dataset.price || 0);
      const compare = Number(option.dataset.comparePrice || 0);

      if (currentPrice) currentPrice.textContent = formatMoney(price, moneyFormat);
      if (comparePrice) {
        comparePrice.textContent = compare > price ? formatMoney(compare, moneyFormat) : '';
        comparePrice.hidden = compare <= price;
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel && addButton) {
        addLabel.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
      }
      if (notifyLink) notifyLink.hidden = available;

      const mediaId = option.dataset.featuredMedia;
      const mediaThumb = mediaId && root.querySelector(`[data-tfw-thumbnail="${CSS.escape(mediaId)}"]`);
      if (mediaThumb) mediaThumb.click();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    };
    variantSelect?.addEventListener('change', setVariantState);

    const quantity = root.querySelector('[data-tfw-quantity] input');
    root.querySelector('[data-tfw-quantity-minus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = Math.max(Number(quantity.min || 1), Number(quantity.value || 1) - 1);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    root.querySelector('[data-tfw-quantity-plus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = Number(quantity.value || 1) + 1;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const gridItems = Array.from(root.querySelectorAll('[data-tfw-media]'));
    const thumbnails = Array.from(root.querySelectorAll('[data-tfw-thumbnail]'));
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbnails.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        const existing = root.querySelector(`[data-tfw-media="${CSS.escape(thumb.dataset.tfwThumbnail)}"]`);
        if (existing) return;

        const primary = root.querySelector('.tfw-gallery-grid__item--1');
        const source = thumb.querySelector('img');
        const target = primary?.querySelector('img');
        if (primary && source && target) {
          target.src = source.currentSrc || source.src;
          target.srcset = source.srcset;
          target.alt = source.alt;
          primary.dataset.tfwMedia = thumb.dataset.tfwThumbnail;
        }
      });
    });

    const dialog = root.querySelector('[data-tfw-media-dialog]');
    const dialogContent = root.querySelector('[data-tfw-media-dialog-content]');
    root.querySelector('[data-tfw-gallery]')?.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tfw-media]');
      if (!trigger || !dialog || !dialogContent) return;
      const image = trigger.querySelector('img');
      if (!image) return;
      dialogContent.replaceChildren(image.cloneNode(true));
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });
    root.querySelector('[data-tfw-media-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-tfw-product]').forEach(initProduct);
  };

  if (!customElements.get('tfw-recommendations')) {
    customElements.define('tfw-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.performed === 'true' || !this.dataset.url || this.dataset.loading === 'true') return;
        this.dataset.loading = 'true';
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const documentFragment = new DOMParser().parseFromString(text, 'text/html');
            const replacement = documentFragment.querySelector('tfw-recommendations');
            if (replacement && replacement.innerHTML.trim()) {
              this.innerHTML = replacement.innerHTML;
              this.dataset.performed = 'true';
            }
          })
          .catch(() => { /* manual fallback products remain visible */ })
          .finally(() => { delete this.dataset.loading; });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
